import request from '@/utils/request'

// 获取对应语言的翻译
export function getLanguageConfig(query){
  return request({
    url: query,
    method: 'get'
  })
}

// 获取工单类型
export function getQuestionType(query){
  return request({
    url: query,
    method: 'get'
  })
}
// 工单(上传图片)
export function uploadImage(data) {
  return request({
    // url: '/v1/question/uploadQaImage',
    // url: 'http://43.156.131.234:1102/v1/question/uploadQaImage', // 测试地址
    // url: 'http://148.153.203.126:1102/v1/question/uploadQaImage',
    url: 'https://bm-wan-cs.wan.com:11102/v1/question/uploadQaImage',//线上地址
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 60000
  })
}
// 提交工单(主体)
export function addQuestion(data){
  return request({
    url: '/v1/question/addQuestion',
    method: 'post',
    data,
    dataType: 'form'
  })
}

// 查询工单列表
export function getQuestionList(query){
  return request({
    url: '/v1/question/queryQuestion',
    methods: 'get',
    params: query
  })
}

// 玩家工单补充
export function replyQuestion(data) {
  return request({
    url: '/v1/question/replyQuestion',
    method: 'post',
    data,
    dataType: 'form'
  })
}

// 结束工单
export function closeQuestion(query) {
  return request({
    url: '/v1/question/closeQuestion',
    method: 'get',
    params: query
  })
}

// FAQ列表
export function getFaqList(url) {
  return request({
    url,
    methods: 'get'
  })
}

// 查询敏感词
export function searchWords(query){
  return request({
    // url: '/v1/question/assertSenvisitiveWords',
    url: '/v1/faq/assertSenvisitiveWords',
    methods: 'get',
    params: query
  }) 
}

// 获取用户打开查询工单页面
// export function uploadUserPoint(data) {
//   return request({
//     url: '/v1/question/openQuestion?questionId='+data,
//     method: 'get',
//     data
//   })
// }

// 获取当前客服语言
export function getCustomerLanguage(data) {
  return request({
    url: data,
    method: 'get'
  })
}

// 翻译当前客服回复的消息
export function translateCustomer(data) {
  return request({
    url: '/v1/translate/content',
    method: 'post',
    data,
    dataType: 'form'
  })
}

// 获取当前用户ip
export function getUserIp() {
  return request({
    url: 'http://api.ipify.org?format=json',
    method: 'get'
  })
}

// 刷新用户已读信息
export function haveRead(data) {
  return request({
    url: '/questionReply/marked/kf/read',
    method: 'post',
    data,
    dataType: 'form'
  })
}